export function uppercaseFirstLetter(str?: string): string {
  if (!str) return ''
  if (str.length === 0) return str
  return str.substring(0, 1).toLocaleUpperCase() + str.substring(1)
}
